import { useNavigate } from 'react-router-dom'
import { useDI } from '@/di/DIContext'

export function useLogout() {
  const navigate = useNavigate()
  const { authService } = useDI()

  const logout = () => {
    // 使用认证服务执行注销逻辑（已包含清除 Token 和 Storage 的逻辑）
    authService.logout()

    // 跳转到登录页
    navigate('/login', { replace: true })
  }

  return { logout }
}
